(function () {
    'use strict';
    angular.module('components.documents', [
        'ngFileUpload',
        'components.config',
        'components.download'
    ]);
})();